import { createFileRoute } from "@tanstack/react-router"

import { DashboardPage } from "#pages/authenticated/dashboard/page.tsx"

export const Route = createFileRoute("/_authenticated/dashboard")({
  staticData: { title: "Dashboard" },
  component: DashboardPage,
})
